// Weekly availability grid — display helpers shared by the staff editor and the
// manager inbox (docs/AVAILABILITY-WEEKLY-GRID-SPEC.md). Pure; no React.
import { fmtClock } from './format.js';

export const DAYS = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];
export const DAY_LABELS = { mon: 'Mon', tue: 'Tue', wed: 'Wed', thu: 'Thu', fri: 'Fri', sat: 'Sat', sun: 'Sun' };

// Whole days from today to the start date — the same noon-UTC math the server
// uses to decide acknowledge (14+) vs approve.
export function leadDays(todayYmd, startsOn) {
  return Math.floor((Date.parse(startsOn + 'T12:00:00Z') - Date.parse(todayYmd + 'T12:00:00Z')) / 86400000);
}

// Days the staffer still has to answer before they can save.
export function unansweredDays(days) {
  return DAYS.filter((d) => !days[d] || (days[d].mode === 'hours' && !(days[d].windows || []).length));
}

// "Mon, Sep 28"
export function fmtDay(ymd) {
  return new Date(ymd + 'T12:00:00Z').toLocaleDateString('en-US', {
    weekday: 'short', month: 'short', day: 'numeric', timeZone: 'UTC',
  });
}

// One availability row in words. Says which way it cuts — the old inbox text
// rendered a whole-day "CAN work" row as "Off".
export function describeRow(r) {
  const days = (r.days && r.days.length ? r.days : (r.day_of_week ? [r.day_of_week] : []))
    .map((d) => DAY_LABELS[d] || d).join(', ');
  const when = r.recurrence === 'one_time' ? fmtDay(r.one_time_date)
    : r.recurrence === 'biweekly' ? `every other ${days}` : `every ${days}`;
  const can = r.kind === 'preference_available';
  if (r.reduction_type === 'full_day') return can ? `Available all day ${when}` : `Off ${when}`;
  return `${can ? 'Available' : 'Off'} ${when}, ${fmtClock(r.start_time)}–${fmtClock(r.end_time)}`;
}

// Pending rows → one review item per grid save; old-form rows stay one each.
export function groupPending(rows) {
  const items = [];
  const bySubmission = new Map();
  for (const r of rows) {
    if (!r.submission_id) { items.push({ key: `row-${r.id}`, rows: [r] }); continue; }
    if (!bySubmission.has(r.submission_id)) {
      const item = { key: `sub-${r.submission_id}`, rows: [] };
      bySubmission.set(r.submission_id, item);
      items.push(item);
    }
    bySubmission.get(r.submission_id).rows.push(r);
  }
  return items;
}
